<template>
  <div>
    <Breadcrumb routeName="OrderList" toName="订单详情" goPathName="订单列表"></Breadcrumb>
    <a-card :bordered="false" style="margin-bottom:15px;">
      <a-row>
        <a-col :span="17">
          <detail-list :col="1" class="order-big">
            <detail-list-item term="订单编号">{{ orderBasicInfo.orderNo }}</detail-list-item>
          </detail-list>
        </a-col>
        <a-col :span="7" class="btns-list">
          <a-button class="mb10" type="primary" v-if="orderBasicInfo.confirmOrRefuseOrderFlag"
                    @click="showOrderModal(0)">确认订单
          </a-button>
          <a-button class="mb10" type="danger" v-if="orderBasicInfo.confirmOrRefuseOrderFlag" ghost
                    @click="showOrderModal(1)">拒绝订单
          </a-button>
          <a-button class="mb10" type="danger" v-if="orderBasicInfo.orderCloseFlag" ghost @click="showCloseOrderModal">
            关闭订单
          </a-button>
          <a-button class="mb10" type="danger" v-if="orderBasicInfo.masterOrderRefundFlag" ghost
                    @click="showkInitRefundModal">主动退款
          </a-button>
          <a-button class="mb10" type="danger" v-if="orderBasicInfo.orderRefundFlag" ghost
                    @click="showRefunkModal(orderBasicInfo.orderSource,orderBasicInfo.orderState)">处理退款
          </a-button>
          <a-button class="mb10" type="primary" v-if="getOrderRemark(orderBasicInfo)" @click="showRemarkModal">
            添加备注
          </a-button>
          <a-button class="mb10" type="primary" v-if="orderBasicInfo.orderShipFlag" @click="showLogisticsModal">
            物流信息
          </a-button>
        </a-col>
      </a-row>
      <a-row>
        <a-col :span="7">
          <detail-list :col="1">
            <detail-list-item term="来源用户">{{ orderBasicInfo.orderMemberInfo }}</detail-list-item>
            <detail-list-item term="下单时间">{{ orderBasicInfo.orderCreateTime }}</detail-list-item>
            <detail-list-item term="支付日期" v-if="orderBasicInfo.orderPayTime">{{ orderBasicInfo.orderPayTime }}
            </detail-list-item>
            <detail-list-item term="支付方式" v-if="orderBasicInfo.orderPayTypeStr">
              {{ orderBasicInfo.orderPayTypeStr }}
            </detail-list-item>
            <detail-list-item term="运费" v-if="orderBasicInfo.orderProType==5">￥{{ orderBasicInfo.expressAmount }}
            </detail-list-item>
            <detail-list-item term="优惠信息" v-if="orderBasicInfo.orderCouponAmt">优惠券
              ￥{{ orderBasicInfo.orderCouponAmt }}
            </detail-list-item>
            <detail-list-item term="员工权益" v-if="orderBasicInfo.orderDiscountAmount">
              ￥{{ orderBasicInfo.orderDiscountAmount }}
            </detail-list-item>
            <!-- 预约单有标准日历及酒店模式日历区别 -->
            <template v-if="orderBasicInfo.orderProType==83">
              <detail-list-item term="入离日期" v-if="orderBasicInfo.orderCheckInDate">
                入：{{ orderBasicInfo.orderCheckInDate }}<br>
                离：{{ orderBasicInfo.orderDepartureDate }}
              </detail-list-item>
              <detail-list-item term="出游日期" v-else>
                {{ orderBasicInfo.orderTravelDate }}
              </detail-list-item>
            </template>
            <template v-else>
              <detail-list-item term="入离日期" v-if="orderBasicInfo.orderProType==2">
                入：{{ orderBasicInfo.orderCheckInDate }}<br>
                离：{{ orderBasicInfo.orderDepartureDate }}
              </detail-list-item>
              <template v-else>
                <detail-list-item term="出游日期" v-if="orderBasicInfo.orderTravelDate&&orderBasicInfo.orderProType!=8">
                  {{ orderBasicInfo.orderTravelDate }}
                </detail-list-item>
              </template>
            </template>
            <detail-list-item term="税费" v-if="orderBasicInfo.orderDirectConnectionType == 24">
              ￥{{ orderBasicInfo.expenses }}
            </detail-list-item>
            <detail-list-item term="芥舟订单号" v-if="orderBasicInfo.orderDirectConnectionType == 24">
              {{ orderBasicInfo.orderThirdOrderNo ? orderBasicInfo.orderThirdOrderNo : '--' }}
            </detail-list-item>
            <detail-list-item term="商品备注" v-if="orderBasicInfo.orderProType==5">{{
                orderBasicInfo.proRemark
              }}
            </detail-list-item>
          </detail-list>
        </a-col>
        <a-col :span="10">
          <detail-list :col="1">
            <detail-list-item v-if="orderBasicInfo.orderProId" term="产品ID">{{ orderBasicInfo.orderProId }}
            </detail-list-item>
            <detail-list-item style="width: 90%;" term="购买商品">{{ orderBasicInfo.orderProName }}</detail-list-item>
            <template v-if="orderBasicInfo.orderOptionName">
              <detail-list-item v-if="orderBasicInfo.orderProType==1" term="票型">{{ orderBasicInfo.orderOptionName }}
              </detail-list-item>
              <detail-list-item v-else-if="orderBasicInfo.orderProType==2" term="房型">
                {{ orderBasicInfo.orderOptionName }}
              </detail-list-item>
              <detail-list-item v-else term="套餐">{{ orderBasicInfo.orderOptionName }}</detail-list-item>
            </template>
            <detail-list-item v-if="orderBasicInfo.orderProType===2" term="价格计划">
              {{ orderBasicInfo.orderRatePlanName }}
            </detail-list-item>
            <detail-list-item term="数量">{{ orderBasicInfo.orderPayNum }}</detail-list-item>
            <detail-list-item term="单价" v-if="orderBasicInfo.priceDetail">{{ orderBasicInfo.priceDetail }}
            </detail-list-item>
            <detail-list-item term="清关状态" v-if="orderBasicInfo.orderDirectConnectionType == 24">
              {{ orderBasicInfo.clearanceStatus == 800 ? '海关放行' : orderBasicInfo.clearanceContent }}
            </detail-list-item>
            <!--{{orderDetail.clearanceStatus==800?'待发货':orderDetail.clearanceContent }}-->
            <detail-list-item term="备注">
              <div v-if="orderBasicInfo.orderMemberRemark">{{ orderBasicInfo.orderMemberRemark }}</div>
              <div v-if="orderBasicInfo.orderRefundRemarks">{{ orderBasicInfo.orderRefundRemarks }}</div>
            </detail-list-item>
          </detail-list>
        </a-col>
        <a-col :span="7">
          <a-row class="status-list">
            <a-col :xs="12" :sm="12">
              <div class="text">状态</div>
              <div class="heading">{{ orderBasicInfo.orderStateStr }}</div>
            </a-col>
            <a-col :xs="12" :sm="12">
              <div class="text">订单金额</div>
              <div class="heading">¥ {{ orderBasicInfo.orderAmt }}</div>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
    </a-card>
    <a-card class="install-ly" v-if="attachedSnapshotList.length>0" title="附加商品"
            style="margin-bottom:15px;padding-top:5px" :bordered="false" :headStyle="{borderBottom:'0px'}">
      <a-row v-for="(item,index) in attachedSnapshotList" :key="index">
        <a-col :span="7">
          <detail-list :col="1">
            <detail-list-item term="商品数量">{{ item.attachedNum }}个</detail-list-item>
            <detail-list-item term="商品单价">￥{{ item.attachedPrice }}</detail-list-item>
          </detail-list>
        </a-col>
        <a-col :span="10">
          <detail-list :col="1">
            <detail-list-item term="商品名称">{{ item.attachedName }}</detail-list-item>
            <detail-list-item term="商品总价">￥{{ item.attachedTotalAmount }}</detail-list-item>
          </detail-list>
        </a-col>
      </a-row>
    </a-card>
    <a-card :bordered="false" :bodyStyle="{padding:'0px'}">
      <a-card v-if="couponCodeList&&couponCodeList.length>0" class="install-ly" title="劵码信息" :bordered="false"
              :headStyle="{borderBottom:'0px'}">
        <a-table
          :columns="getCodeColumns()"
          rowKey="key"
          :dataSource="couponCodeList" :pagination="false">
          <template slot="actionOrderNo" slot-scope="text,record">
            <a v-if="record.reserveOrderNo" @click="onClickOrderNo(record)">{{ record.reserveOrderNo }}</a>
            <span v-else>--</span>
          </template>
          <span slot="action" slot-scope="text,record">
            <template v-if="record.codeUseStatus===0">
              <a v-if="record.codeSmsStatus===0" @click="onClickSend(record)">发送</a>
              <a v-else-if="record.codeSmsStatus===1" @click="onClickSend(record)">重新发送</a>
            </template>
            <template v-if="record.codeUseStatus==0">
              <a-divider type="vertical"></a-divider>
              <a-popconfirm title="是否要作废该条数据?" @confirm="onClickCancel(record)">
                <a>作废</a>
              </a-popconfirm>
            </template>
          </span>
        </a-table>
      </a-card>
      <a-card class="install-ly" title="联系人信息" :bordered="false" :headStyle="{borderBottom:'0px'}">
        <detail-list :col="1">
          <detail-list-item term="姓名">{{ orderContactInfo.orderContact }}</detail-list-item>
          <detail-list-item term="收货地址" v-if="orderContactInfo.orderContactReceiptAddress">
            {{ orderContactInfo.orderContactReceiptAddress }}
          </detail-list-item>
          <detail-list-item term="联系电话">{{ orderContactInfo.orderContactMobile }}</detail-list-item>
          <template v-if="orderContactInfo.orderContactInfo&&orderContactInfo.orderContactInfo.length>0">
            <detail-list-item v-for="(item,index) in orderContactInfo.orderContactInfo" :key="index" :term="item.name">
              {{ item.text }}
            </detail-list-item>
          </template>
          <detail-list-item v-if="orderBasicInfo.employeeCardImg" term="员工证件照">
            <img class="employee-card-img" :src="orderBasicInfo.employeeCardImg" alt=""
                 @click="previewEvent(orderBasicInfo.employeeCardImg)">
          </detail-list-item>
        </detail-list>
      </a-card>
      <a-card class="install-ly" v-if="orderPersonnelList&&orderPersonnelList.length>0" :bordered="false"
              :headStyle="{borderBottom:'0px'}">
        <template slot="title">
          <span>{{ filterTravelText(orderBasicInfo.orderProType) }}</span>
        </template>
        <a-table
          :columns="personColumns"
          rowKey="key"
          :dataSource="orderPersonnelList" :pagination="false">
        </a-table>
      </a-card>
      <a-card class="install-ly" v-if="orderBasicInfo.orderProType==6&&orderReceiptVO.receiptContactName"
              title="收货地址" :bordered="false" :headStyle="{borderBottom:'0px'}">
        <detail-list :col="1">
          <detail-list-item term="姓名">{{ orderReceiptVO.receiptContactName }}</detail-list-item>
          <detail-list-item term="联系电话">{{ orderReceiptVO.receiptContactPhone }}</detail-list-item>
          <detail-list-item term="收货地址">{{ orderReceiptVO.receiptReceivingAddress }}</detail-list-item>
        </detail-list>
      </a-card>
      <a-card class="install-ly" title="结算信息" v-if="orderSettlementInfo" :bordered="false"
              :headStyle="{borderBottom:'0px'}">
        <detail-list :col="1">
          <detail-list-item term="供应商" v-if="orderSettlementInfo.orderSupplierSettlement">
            {{
              orderSettlementInfo.orderSupplierSettlement.merchantName
            }}（联系人姓名：{{ orderSettlementInfo.orderSupplierSettlement.merchantContact }}
            ，电话：{{ orderSettlementInfo.orderSupplierSettlement.merchantMobile }}）<span
            v-if="orderSettlementInfo.orderSupplierSettlement.orderIncomeAmt">实收：￥{{
              orderSettlementInfo.orderSupplierSettlement.orderIncomeSum
            }}&nbsp;&nbsp;<span
              v-if="orderSettlementInfo.orderSupplierSettlement.orderRefundAmt">({{
                orderSettlementInfo.orderSupplierSettlement.orderIncomeAmt
              }} - {{ orderSettlementInfo.orderSupplierSettlement.orderRefundAmt }})</span></span>
          </detail-list-item>

          <detail-list-item term="分销商佣金" v-if="orderSettlementInfo.orderDistributionSettlement">
            {{
              orderSettlementInfo.orderDistributionSettlement.merchantName
            }}（联系人姓名：{{ orderSettlementInfo.orderDistributionSettlement.merchantContact }}
            ，电话：{{ orderSettlementInfo.orderDistributionSettlement.merchantMobile }}） <span
            v-if="orderSettlementInfo.orderDistributionSettlement.orderIncomeAmt">实收：￥{{
              orderSettlementInfo.orderDistributionSettlement.orderIncomeSum
            }}&nbsp;&nbsp; <span
              v-if="orderSettlementInfo.orderDistributionSettlement.orderRefundAmt">({{
                orderSettlementInfo.orderDistributionSettlement.orderIncomeAmt
              }} - {{ orderSettlementInfo.orderDistributionSettlement.orderRefundAmt }})</span></span>
          </detail-list-item>

          <detail-list-item term="分销员佣金" v-if="orderSettlementInfo.orderShareStaffSettlement">
            {{
              orderSettlementInfo.orderShareStaffSettlement.merchantName
            }}（联系人姓名：{{ orderSettlementInfo.orderShareStaffSettlement.merchantContact }}
            ，电话：{{ orderSettlementInfo.orderShareStaffSettlement.merchantMobile }}）<span
            v-if="orderSettlementInfo.orderShareStaffSettlement.orderIncomeAmt">实收：￥{{
              orderSettlementInfo.orderShareStaffSettlement.orderIncomeSum
            }}&nbsp;&nbsp;<span
              v-if="orderSettlementInfo.orderShareStaffSettlement.orderRefundAmt">({{
                orderSettlementInfo.orderShareStaffSettlement.orderIncomeAmt
              }} - {{ orderSettlementInfo.orderShareStaffSettlement.orderRefundAmt }})</span></span>
          </detail-list-item>

          <detail-list-item term="分销员佣金" v-if="orderSettlementInfo.orderStaffSettlement">
            {{
              orderSettlementInfo.orderStaffSettlement.merchantName
            }}（联系人姓名：{{ orderSettlementInfo.orderStaffSettlement.merchantContact }}
            ，电话：{{ orderSettlementInfo.orderStaffSettlement.merchantMobile }}）<span
            v-if="orderSettlementInfo.orderStaffSettlement.orderIncomeAmt">实收：￥{{
              orderSettlementInfo.orderStaffSettlement.orderIncomeSum
            }}&nbsp;&nbsp;<span
              v-if="orderSettlementInfo.orderStaffSettlement.orderRefundAmt">({{
                orderSettlementInfo.orderStaffSettlement.orderIncomeAmt
              }} - {{ orderSettlementInfo.orderStaffSettlement.orderRefundAmt }})</span></span>
          </detail-list-item>

        </detail-list>
      </a-card>
      <!--      <a-card class="install-ly" v-if="orderShip&&orderShip.length>0" title="发货信息" :bordered="false" :headStyle="{borderBottom:'0px'}">-->
      <!--        <detail-list :col="3" v-for="(item,index) in orderShip" :key="index">-->
      <!--          <detail-list-item term="发货时间">{{item.expressTime}}</detail-list-item>-->
      <!--          <detail-list-item term="快递公司">{{item.expressCompanyName}}</detail-list-item>-->
      <!--          <detail-list-item term="快递单号">{{item.expressNo}}</detail-list-item>-->
      <!--        </detail-list>-->
      <!--      </a-card>-->
      <a-card class="install-ly" v-if="orderRefund" title="退款信息" :bordered="false"
              :headStyle="{borderBottom:'0px'}">
        <detail-list :col="6">
          <detail-list-item term="申请退款时间">{{ orderRefund.orderRefundStartTime }}</detail-list-item>
          <detail-list-item term="申请退款金额">{{ orderRefund.orderApplyRefundAmt }}元</detail-list-item>
          <detail-list-item term="申请退款数量">{{ orderRefund.orderRefundNum }}</detail-list-item>
          <detail-list-item term="实际退款时间" v-if="orderRefund.orderRefundEndTime">
            {{ orderRefund.orderRefundEndTime }}
          </detail-list-item>
          <detail-list-item term="实际退款金额" v-if="orderRefund.orderRefundAmt">{{ orderRefund.orderRefundAmt }}元
          </detail-list-item>
          <detail-list-item term="供应商退款金额" v-if="orderRefund.supplierRefundAmt">
            {{ orderRefund.supplierRefundAmt }}元
          </detail-list-item>
          <!-- <detail-list-item term="销售员佣金退款">0元</detail-list-item> -->
        </detail-list>
      </a-card>
      <a-card class="install-ly" title="退款人信息"
              v-if="orderRefund&&orderRefund.refundCustomerList&&orderRefund.refundCustomerList.length>0"
              :bordered="false" :headStyle="{borderBottom:'0px'}">
        <a-table
          :columns="getRefundColumns()"
          rowKey="key"
          :dataSource="orderRefund.refundCustomerList" :pagination="false">
        </a-table>
      </a-card>
      <template v-if="orderBasicInfo.orderProviderRemark||orderBasicInfo.orderDistributorRemark">
        <a-card class="install-ly" title="备注信息" :bordered="false" :headStyle="{borderBottom:'0px'}">
          <detail-list :col="1">
            <detail-list-item v-if="orderBasicInfo.orderProviderRemark" term="供应商备注">
              <ul class="ul-lh">
                <li v-for="(item,index) in orderBasicInfo.orderProviderRemarkList" :key="index" v-show="item!=''">
                  {{ item }}
                </li>
              </ul>
            </detail-list-item>
            <detail-list-item v-if="orderBasicInfo.orderDistributorRemark" term="分销商备注">
              <ul class="ul-lh">
                <li v-for="(item,index) in orderBasicInfo.orderDistributorRemarkList" :key="index" v-show="item!=''">
                  {{ item }}
                </li>
              </ul>
            </detail-list-item>
          </detail-list>
        </a-card>
      </template>
      <template v-if="authAuditOrderVo && authAuditOrderVo.auditStatusStr">
        <a-card class="install-ly" title="审批信息" :bordered="false" :headStyle="{borderBottom:'0px'}">
          <detail-list :col="1">
            <detail-list-item v-if="authAuditOrderVo.auditStatusStr" term="审批状态">
              <ul class="ul-lh">
                <li>{{ authAuditOrderVo.auditStatusStr }}</li>
              </ul>
            </detail-list-item>
            <detail-list-item v-if="authAuditOrderVo.stepRemarks&& authAuditOrderVo.stepRemarks.length" term="审批流程">
              <ul class="ul-lh">
                <a-steps direction="vertical" :current="authAuditOrderVo.stepRemarks.length">
                  <a-step
                    v-for="(item,index) in authAuditOrderVo.stepRemarks"
                    :key="index"
                    :title="item.auditRemark"
                    :description="'审核人：'+item.auditName+' '+item.auditValue+' '+item.updateTime"/>
                </a-steps>
              </ul>
            </detail-list-item>
          </detail-list>
        </a-card>
      </template>
      <template v-if="orderBasicInfo.orderSuccessSms">
        <a-card class="install-ly" title="预约信息" :bordered="false" :headStyle="{borderBottom:'0px'}">
          <detail-list :col="1">
            <detail-list-item>{{ orderBasicInfo.orderSuccessSms }}</detail-list-item>
          </detail-list>
        </a-card>
      </template>
      <a-card
        class="install-ly"
        title="物流信息"
        style="margin-bottom:15px;padding-top:5px"
        v-if="orderShip&&orderShip.length>0"
        :bordered="false"
        :headStyle="{borderBottom:'0px'}">
        <a-tabs size="small" v-model="shipIndex" @change="changeShipEvent">
          <a-tab-pane v-for="(item,index) in orderShip" :key="index" :tab="'物流信息'+(index+1)">
          </a-tab-pane>
        </a-tabs>
        <a-row>
          <a-col :span="7">
            <detail-list :col="1">
              <detail-list-item term="物流公司">{{ orderShipInfo.expressCompanyName }}</detail-list-item>
            </detail-list>
          </a-col>
          <a-col :span="10">
            <detail-list :col="1">
              <detail-list-item term="物流单号">{{ orderShipInfo.expressNo }}</detail-list-item>
            </detail-list>
          </a-col>
        </a-row>
        <a-timeline style="margin-left: 50px;" class="time-line" v-if="orderShipInfo&&orderShipInfo.logisticsInfos">
          <a-timeline-item v-for="(item,index) in orderShipInfo.logisticsInfos" :key="index">
            <div>{{ item.time }}</div>
            <div>{{ item.msg }}</div>
          </a-timeline-item>
        </a-timeline>
        <div
          v-if="orderShipInfo.expressType == 0&&(!orderShipInfo.logisticsInfos||!orderShipInfo.logisticsInfos.length)">
          当前物流单号未订阅物流信息，而无法显示。如需显示，请前往服务《快递查询》模块 购买物流查询数量后，点击
          <a-button size="small" type="primary" @click="refreshLogistics">刷新</a-button>
          。 重新订阅物流轨迹信息。
        </div>
      </a-card>
    </a-card>
    <!-- 确认订单 -->
    <a-modal :title="confirmOrderType==0?'确认订单':'拒绝订单'"
             :visible="confirmOrderVisible"
             @ok="handleOrderBtns"
             :confirmLoading="confirmLoading"
             @cancel="handleCancel"
    >
      <a-textarea v-model="confirmOrderRemark" placeholder="请输入备注" :maxLength="300" :rows="4"/>
    </a-modal>
    <!-- 退款 -->
    <!-- 备注 -->
    <a-modal title="添加备注"
             :visible="remarkVisible"
             @ok="addMerchantRemark"
             :confirmLoading="confirmLoading"
             @cancel="handleCancel"
    >
      <a-textarea v-model="merchantRemark" placeholder="请输入备注" :maxLength="300" :rows="4"/>
    </a-modal>
    <!-- 退款 -->
    <a-modal title="确认退款"
             :visible="refundVisible"
             @ok="handleSubmit"
             @cancel="handleCancel"
             :confirmLoading="confirmLoading"
             :width="600"
    >
      <a-form :form="form">
        <a-form-item label="退款处理" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }" required>
          <a-radio-group v-decorator="['reundLogAgreeOrCancel']" @change="onRefunkChange">
            <a-radio :value="1">同意退款</a-radio>
            <a-radio v-if="refundType!=2" :value="2">拒绝退款</a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item v-if="refundType!=1&&reundLogAgreeOrCancel==1" label="退款金额" :label-col="{ span: 5 }"
                     :wrapper-col="{ span: 19 }">
          <a-input prefix="￥" :placeholder="orderBasicInfo.refundMinAmt+'-'+orderBasicInfo.refundMaxAmt" suffix="RMB"
                   v-decorator="['reundLogAmount', { rules: [{ required: true, message: '请输入退款金额' },{pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/, message: '请输入正确金额',}] }]"/>
        </a-form-item>
        <a-form-item v-if="refundType!=1" label="最大退款金额" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          {{ orderBasicInfo.refundMaxAmt }}元
        </a-form-item>
        <template v-if="refundType!=1&&reundLogAgreeOrCancel==1&&orderBasicInfo.refundCommissionFlag">
          <a-form-item label="扣分销佣金" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input prefix="￥" :placeholder="'0-'+orderBasicInfo.refundCommissionAmount" suffix="RMB"
                     v-decorator="['refundCommissionAmount', { rules: [{ required: true, message: '请输入扣分销佣金' },{pattern: /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/, message: '请输入正确金额',}] }]"/>
          </a-form-item>
          <a-form-item style="margin-bottom:0;" label="客户可得金额" :label-col="{ span: 5 }"
                       :wrapper-col="{ span: 19 }">
            退款金额+扣分销佣金金额
          </a-form-item>
        </template>

      </a-form>
    </a-modal>

    <!-- 补差 -->
    <a-modal title="重要提示"
             :visible="continueVisible"
             @ok="continueRefund"
             @cancel="handleContinueCancel"
             :width="500"
    >
      <p>当前二分账户佣金余额不足，继续退款将从您的账户扣除 ￥{{ compensationMoney }}用于补差，是否继续？</p>
    </a-modal>

    <!-- 主动退款 -->
    <a-modal title="主动退款"
             :visible="InitRefundVisible"
             @ok="handleInitRefund"
             :confirmLoading="confirmLoading"
             @cancel="handleCancel"
             :width="650"
    >
      <a-form :form="refundform">
        <!--  v-if="orderBasicInfo.orderSourceDisplay==2||orderBasicInfo.orderSourceDisplay==3||orderBasicInfo.orderSourceDisplay==4"-->
        <template v-if="isThinkRefund">
          <a-form-item label="退款金额" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input prefix="￥" suffix="RMB" placeholder="请输入"
                     v-decorator="['reundLogThinkAmount', { rules: [{ required: true, message: '请输入退款金额' },{pattern: /^(?!0+(?:\.0+)?$)(?:[1-9]\d{0,6}|0)(?:\.\d{1,2})?$/, message: '请输入正确金额',}] }]"/>
          </a-form-item>
          <a-form-item label="最大退款金额" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            {{ orderBasicInfo.refundMaxAmt }}元
          </a-form-item>
          <template v-if="orderBasicInfo.refundCommissionFlag">
            <a-form-item label="扣分销佣金" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
              <a-input prefix="￥" :placeholder="'0-'+orderBasicInfo.refundCommissionAmount" suffix="RMB"
                       v-decorator="['refundCommissionAmount', { rules: [{ required: true, message: '请输入扣分销佣金' },{pattern: /((^[1-9]\d*)|^0)(\.\d{0,2}){0,1}$/, message: '请输入正确金额',}] }]"/>
            </a-form-item>
            <a-form-item style="margin-bottom:0;" label="客户可得金额" :label-col="{ span: 5 }"
                         :wrapper-col="{ span: 19 }">
              退款金额+扣分销佣金金额
            </a-form-item>
          </template>

        </template>
        <a-form-item label="退款备注" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-textarea v-decorator="['refundRemarks', { rules: [{ required: true, message: '请输入退款备注' }] }]"
                      placeholder="请输入备注" :maxLength="300" :rows="4"/>
        </a-form-item>
      </a-form>
    </a-modal>
    <!-- 物流信息 -->
    <a-modal title="物流信息"
             :visible="logisticsVisible"
             @ok="handleLogisticsOk"
             :confirmLoading="confirmLoading"
             @cancel="handleLogisticsCancel"
             :width="600"
    >
      <div class="model-box">
        <a-form-model
          ref="logisticsForm"
          :model="logisticsForm"
        >
          <a-form-model-item v-for="(dtoList, index) in logisticsForm.dtoList" :key="index">
            <a-form-model-item
              style="display:inline-block"
              :prop="'dtoList.' + index + '.expressCompanyName'"
              :rules="{
                required: true,
                message: '物流公司名不能为空',
                trigger: ['change', 'blur']
              }"
            >
              <a-select
                show-search
                placeholder="请选择物流公司"
                option-filter-prop="children"
                style="width: 200px"
                v-model="dtoList.expressCompanyName"
                :disabled="dtoList.isDisabled"
                @popupScroll="popupScrollEvent"
                @search="fetchSearch"
                @focus="focusEvent"
              >
                <a-select-option v-for="(item,index) in logisticsCompany" :key="index" :value="item.companyName">
                  {{ item.companyName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            <a-form-model-item
              style="display:inline-block;margin-left: 20px"
              :prop="'dtoList.' + index + '.expressNo'"
              :rules="{
                required: true,
                message: '物流单号不能为空',
                trigger: ['change', 'blur']
              }"
            >
              <a-input
                :disabled="dtoList.isDisabled"
                v-model="dtoList.expressNo"
                placeholder="请输入物流单号"
              />
            </a-form-model-item>
            <a-icon
              style="display:inline-block;margin-left: 20px"
              v-if="logisticsForm.dtoList.length > 1"
              class="dynamic-delete-button"
              type="minus-circle-o" :disabled="logisticsForm.dtoList.length === 1"
              @click="() => remove(dtoList,index)"
            />
          </a-form-model-item>
        </a-form-model>
      </div>
      <a-row type="flex">
        <a-col :span="20">
          <a-button type="dashed" @click="add">
            <a-icon type="plus"/>
            新增物流信息
          </a-button>
        </a-col>
      </a-row>
    </a-modal>
    <!--  '发送电子码':'发送预约码'  -->
    <couponSendMessageDialog
      :isElectronicCode="isElectronicCode"
      :visible="couponSendDialogVisible"
      :loading="submitSendLoading"
      :sendForm="sendForm"
      @cancel="cancelDialog"
      @submitData="submitSendEvent"
    >
    </couponSendMessageDialog>
    <!-- 员工证件照预览 -->
    <PreviewImage
      v-if="imgDialogVisible"
      :dialogVisible="imgDialogVisible"
      :imageUrl="imageUrl"
      @close="imgDialogVisible = false"
      title="员工证件照"
    />
  </div>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import formMixins from '../../../utils/mixins/formMixins'
import couponSendMessageDialog from '../../service/components/couponSendMessageDialog'
import PreviewImage from '@/views/platform/component/PreviewImage'

export default {
  name: 'OrderDetails',
  mixins: [formMixins],
  components: {
    Breadcrumb,
    couponSendMessageDialog,
    PreviewImage
  },
  data() {
    return {
      currentFormLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 16 }
      },
      refundform: this.$form.createForm(this),
      logisticsForm: {
        dtoList: [{
          expressCompanyName: undefined,
          expressNo: ''
        }]
      },
      orderNo: this.$route.query.orderNo,
      merchantId: this.$store.getters.userInfo.merchantId,
      remarkVisible: false,
      refundVisible: false,
      continueVisible: false,
      confirmOrderVisible: false,
      InitRefundVisible: false,
      logisticsVisible: false,
      orderBasicInfo: {},//主体信息
      orderContactInfo: {},//联系人信息
      orderSettlementInfo: '',
      orderShip: [],
      orderRefund: '',
      confirmLoading: false,
      orderPersonnelList: [],
      personColumns: [
        {
          title: '姓名',
          key: 'ocustomerInfoName',
          dataIndex: 'ocustomerInfoName'
        },
        {
          title: '证件类型',
          key: 'ocustomerInfoCardTypeStr',
          dataIndex: 'ocustomerInfoCardTypeStr'
        },
        {
          title: '证件号',
          key: 'ocustomerInfoIdCard',
          dataIndex: 'ocustomerInfoIdCard'
        },
        {
          title: '性别',
          key: 'ocustomerSex',
          dataIndex: 'ocustomerSex'
        },
        {
          title: '联系电话',
          key: 'ocustomerInfoPhone',
          dataIndex: 'ocustomerInfoPhone'
        }
      ],
      merchantRemark: '',//保存备注信息
      confirmOrderRemark: '',//确认订单保存备注
      reundLogAgreeOrCancel: 1,
      orderState: 0, //订单状态:0已确认1未确认2商家已拒绝3已关闭4申请退款5分销商同意退款6供应商同意退款7供应商拒绝退款8已退款(最终状态)9拒绝退款(最终状态) ,
      orderSource: 0, //订单来源:1一级分销商销售订单(分销订单) 2一级分销商的二级分销商销售订单(分销订单) 3自有商品订单(自销订单) 4一级分销商采购的订单(分销采购订单) 5供应商的二级分销商销售订单(分销订单) 6一级分销商的二级分销商采购订单(分销采购订单) 7供应商的二级分销商采购订单(分销采购订单)' ,
      refundType: 1,//1是一分第一次退款 2是一分第二次退款 3是供应商退款
      compensationMoney: 0,//一分补差金额
      compensationType: '',//1是供应商 分销商（补差）2是主动退款的供应商
      compensationFlag: false,//补差
      accountMoney: 0,//账户余额
      confirmOrderType: 0, // 0确认  1拒绝
      refundCommissionAmount: 0,//分销佣金
      attachedSnapshotList: [],//附加商品信息
      orderReceiptVO: {},//机票报销凭证收货地址
      couponCodeList: [],
      couponSendDialogVisible: false,
      submitSendLoading: false,
      sendForm: {
        phone: '',
        message: '',
        orderNo: '',
        smsContent: '',
        redeemCode: '',
        couponId: '',
        sendFlag: false
      },
      isElectronicCode: false,//电子码为true; 通用券码为false
      orderShipInfo: {},
      shipIndex: 0,
      logisticsNumber: 0,
      logisticsCompany: [],
      scrollPage: 1,
      curPage: 1,
      pageCount: 1,
      isThinkRefund: true,//自有产品订单(自销订单)",3
      imgDialogVisible: false,
      imageUrl: '',
      authAuditOrderVo: undefined
    }
  },
  activated() {
    this.getUpdateDate()
  },
  mounted() {

  },
  methods: {
    getCourierServicesCompany(pageNum, value) {
      let params = {
        companyName: value ? value : '',
        limitDto: {
          pageNum: pageNum,
          pageSize: 20
        }
      }
      this.getHttpServices().getServerApiService().post('express/base/list', params)
        .then(res => {
          if (pageNum == 1) {
            this.logisticsCompany = res.data
          } else {
            this.logisticsCompany = this.logisticsCompany.concat(res.data)
          }
          this.curPage = res.curPage
          this.pageCount = res.pageCount
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    popupScrollEvent(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target
      if (scrollTop + clientHeight + 1 >= scrollHeight) {
        this.scrollPage++
        if (this.curPage < this.pageCount) {
          this.getCourierServicesCompany(this.scrollPage)
        }
      }
    },
    refreshLogistics() {
      let params = {
        expressNo: this.orderShipInfo.expressNo,
        orderNo: this.orderNo
      }
      this.getHttpServices().getOrderService().post('api/v2/orderManage/refreshOrderExpress', params)
        .then(res => {
          this.$message.success('订阅成功')
          this.getOrderDetails()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    focusEvent() {
      this.scrollPage = 1
      this.logisticsCompany = []
      this.getCourierServicesCompany(this.scrollPage)
    },
    fetchSearch(value) {
      this.getCourierServicesCompany(this.scrollPage, value)
    },
    changeShipEvent(e) {
      this.orderShipInfo = this.orderShip[e]
    },
    filterTravelText(type) {
      if (type == 2) {
        return '入住人信息'
      } else if (type == 1 || type == 4 || type == 8 || type == 83) {
        return '游玩人信息'
      } else {
        return '出行人信息'
      }
    },
    getUpdateDate() {
      this.orderNo = this.$route.query.orderNo
      this.merchantRemark = ''//保存备注信息
      this.confirmOrderRemark = ''//确认订单保存备注
      this.reundLogAgreeOrCancel = 1
      this.orderState = 0 //订单状态:0已确认1未确认2商家已拒绝3已关闭4申请退款5分销商同意退款6供应商同意退款7供应商拒绝退款8已退款(最终状态)9拒绝退款(最终状态) ,
      this.orderSource = 0 //订单来源:1一级分销商销售订单(分销订单) 2一级分销商的二级分销商销售订单(分销订单) 3自有商品订单(自销订单) 4一级分销商采购的订单(分销采购订单) 5供应商的二级分销商销售订单(分销订单) 6一级分销商的二级分销商采购订单(分销采购订单) 7供应商的二级分销商采购订单(分销采购订单)' ,
      this.refundType = 1//1是一分第一次退款 2是一分第二次退款 3是供应商退款
      this.compensationMoney = 0//一分补差金额
      this.compensationType = ''//1是供应商 分销商（补差）2是主动退款的供应商
      this.compensationFlag = false//补差
      this.accountMoney = 0//账户余额
      this.confirmOrderType = 0 // 0确认  1拒绝
      this.remarkVisible = false
      this.refundVisible = false
      this.continueVisible = false
      this.confirmOrderVisible = false
      this.InitRefundVisible = false
      this.logisticsVisible = false
      this.orderShip = []
      this.orderRefund = ''
      this.confirmLoading = false
      this.orderPersonnelList = []
      this.couponCodeList = []
      this.couponSendDialogVisible = false
      this.submitSendLoading = false
      this.sendForm = {
        phone: '',
        message: '',
        orderNo: '',
        smsContent: '',
        redeemCode: '',
        couponId: '',
        sendFlag: true
      }
      this.logisticsNumber = 0
      this.isElectronicCode = false//电子码为true; 通用券码为false
      this.isThinkRefund = true
      //接口获取
      this.getOrderDetails()
      this.getAccountMoney()
      this.getOrderAuditDetail(this.orderNo)
    },
    handleLogisticsCancel() {
      this.logisticsVisible = false
    },
    showRemarkModal() {
      this.remarkVisible = true
    },
    showRefunkModal(orderSource, orderState) {
      if (orderSource == 1 || orderSource == 2 || orderSource == 6) {
        if (orderState == 4) {
          //分销商一次确认
          this.refundType = 1
        } else if (orderState == 5) {
          //供应商确认
          this.refundType = 3
        } else if (orderState == 6 || orderState == 7) {
          //分销商二次确认
          this.refundType = 2
        }
      } else if (orderSource == 3 || orderSource == 5 || orderSource == 8 || orderSource == 9) {
        this.refundType = 3
        this.reundLogAmount = 0
      }
      this.refundVisible = true
      this.orderSource = orderSource
      this.orderState = orderState
      this.$nextTick(() => {
        this.form.setFieldsValue({
          reundLogAgreeOrCancel: 1
        })
      })
    },
    // 拒绝、确认订单
    showOrderModal(type) {
      this.confirmOrderType = type
      this.confirmOrderVisible = true
    },
    handleOrderBtns(e) {
      e.preventDefault()
      let parmas = new Object()
      parmas.operateType = this.confirmOrderType
      parmas.orderNo = this.orderNo
      parmas.orderProviderRemark = this.confirmOrderRemark
      this.confirmLoading = true
      this.getHttpServices().getPayApiService().post('order/operateOrder', parmas).then(res => {
        this.confirmOrderVisible = false
        let title = this.confirmOrderType == 0 ? '确认订单' : '拒绝订单'
        this.$message.success(title + '成功')
        this.confirmOrderRemark = ''
        this.getOrderDetails()
      }).catch(reason => {
        this.getLogUtils().logWithTag('错误信息', reason)
        this.showNetWorkErrorMessage(reason)
      }).finally(() => this.confirmLoading = false)
    },
    handleCancel(e) {
      this.getLogUtils().logWithTag('Clicked cancel button')
      this.remarkVisible = false
      this.refundVisible = false
      this.confirmOrderVisible = false
      this.InitRefundVisible = false
    },
    // 关闭补差弹窗
    handleContinueCancel() {
      this.continueVisible = false
    },
    // 补差确认
    continueRefund() {
      this.compensationFlag = true
      if (this.compensationType == 1) {
        this.merchantReundBts()
      } else {
        // 主动退款
        this.getApplyRefund()
      }
    },
    // 账户余额
    getAccountMoney() {
      this.getHttpServices().getUserService().get('user/merchantAccount/getMerchantAccount').then(res => {
        this.getLogUtils().logWithTag('==getAccountMoney==', res)
        this.accountMoney = res.accountAbledrawcash
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    /**
     * 获取审核信息
     * @param orderNo
     */
    getOrderAuditDetail(orderNo) {
      const url = `member/v3/auth/getOrderAuditDetail/${orderNo}`
      this.getHttpServices().getMemberAuthService().post(url)
        .then(res => {
          this.authAuditOrderVo = res ? { ...res } : undefined
        })
        .catch(reason => {
          console.error(reason)
        })
    },
    getOrderDetails() {
      this.getHttpServices().getOrderService().post('api/v2/orderManage/getOrderDetails', {
        orderNo: this.orderNo
      }).then(res => {
        this.getLogUtils().logWithTag('==getPayStateList==', res)
        this.orderBasicInfo = res.orderBasic
        this.orderContactInfo = res.orderContact
        this.orderSettlementInfo = res.orderSettlement ? res.orderSettlement : ''
        let orderSourceList = [3, 5, 7, 8, 9, 10, 11, 12]
        this.isThinkRefund = orderSourceList.includes(res.orderBasic.orderSource)
        this.orderShip = res.orderShip ? res.orderShip : []
        this.orderShipInfo = res.orderShip ? res.orderShip[0] : {}
        this.orderRefund = res.orderRefund ? res.orderRefund : ''
        this.orderReceiptVO = res.orderReceiptVO ? res.orderReceiptVO : {}
        let orderPersonnelList = res.orderPersonnel ? res.orderPersonnel : []
        if (orderPersonnelList && orderPersonnelList.length > 0) {
          orderPersonnelList.forEach(item => {
            if (item.ocustomerInfoSex) {
              item.ocustomerSex = item.ocustomerInfoSex
            } else {
              if (item.ocustomerInfoIdCardType == 1) {
                item.ocustomerSex = item.ocustomerInfoIdCard ? (parseInt(item.ocustomerInfoIdCard.substr(16, 1)) % 2 == 1) ? '男' : '女' : ''
              }
            }
          })
        }
        this.orderPersonnelList = orderPersonnelList
        this.attachedSnapshotList = res.attachedSnapshotList ? res.attachedSnapshotList : []
        this.getLogUtils().logWithTag('this.attachedSnapshotList', this.attachedSnapshotList)
        if (this.orderPersonnelList.length > 0) {
          this.orderPersonnelList.forEach((item, index) => {
            this.$set(item, 'key', index)
          })
        }
        if (res.orderBasic && res.orderBasic.orderProType == 8) {
          this.getCouponCodeInfo()
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    //验证
    checkRemark() {
      if (!this.merchantRemark) {
        this.$message.error('请输入需要备注的信息')
        return false
      }
      return true
    },
    onRefunkChange(e) {
      this.getLogUtils().logWithTag('radio checked', e.target.value)
      this.reundLogAgreeOrCancel = e.target.value
    },
    // 保存退款表单数据
    handleSubmit(e) {
      this.validateFormParams().then(res => {
        this.getLogUtils().logWithTag('默认表单数据', res)
        this.reundLogAmount = res.reundLogAmount
        this.reundLogAgreeOrCancel = res.reundLogAgreeOrCancel ? res.reundLogAgreeOrCancel : ''
        this.refundCommissionAmount = res.refundCommissionAmount
        this.merchantReundBts()
      })
    },
    // 验证退款逻辑
    checkMerchantReund() {
      if (this.refundType == 1) {
        return true
      } else {
        if (this.reundLogAgreeOrCancel == 1) {//同意退款
          if (Number(this.reundLogAmount) > Number(this.orderBasicInfo.refundMaxAmt)) {
            this.$message.error('退款金额不能大于最大退款金额')
            return false
          }
          if (Number(this.reundLogAmount) < Number(this.orderBasicInfo.refundMinAmt)) {
            this.$message.error('退款金额不能小于' + this.orderBasicInfo.refundMinAmt + '元')
            return false
          }
          if (this.orderBasicInfo.refundCommissionFlag) {
            if (Number(this.refundCommissionAmount) > this.orderBasicInfo.refundCommissionAmount) {
              this.$message.error('扣分销佣金不能大于最大可扣金额')
              return false
            }
          }
          if (this.refundType == 2) {
            if (Number(this.reundLogAmount - this.supplierRefundAmout) > Number(this.accountMoney / 100)) {
              this.$message.error('账户余额不足，请充值后退款')
              return false
            }
          } else {
            if (Number(this.reundLogAmount) > Number(this.accountMoney / 100)) {
              this.$message.error('账户余额不足，请充值后退款')
              return false
            }
          }
        }
        return true
      }
    },
    // 运营商退款
    merchantReundBts() {
      if (this.checkMerchantReund()) {
        let parmas = new Object()
        parmas.refundLogUserId = this.$store.getters.userInfo.merchantId
        parmas.orderSource = this.orderSource
        parmas.orderState = this.orderState
        parmas.refundLogOrderNo = this.orderNo
        parmas.reundLogAgreeOrCancel = this.reundLogAgreeOrCancel
        parmas.reundLogAmount = this.reundLogAmount
        parmas.flag = this.compensationFlag
        parmas.refundCommissionAmount = this.refundCommissionAmount
        this.confirmLoading = true
        this.getHttpServices().getPayApiService().post('refund/refundOperation', parmas).then(res => {
          this.refundVisible = false
          this.continueVisible = false
          this.getOrderDetails()
          let title = this.reundLogAgreeOrCancel == 1 ? '同意' : '拒绝'
          this.reundLogAmount = ''
          if (this.refundType = 1) {
            this.$message.success(title + '退款成功')
          } else if (this.refundType = 2) {
            this.$message.success('退款成功')
          } else {
            this.$message.success(title + '退款成功')
          }
        }).catch(reason => {
          this.getLogUtils().logWithTag('错误信息', reason)
          if (reason.status == -164) {
            this.continueVisible = true
            this.compensationMoney = reason.data
            this.compensationType = 1
          }
          this.showNetWorkErrorMessage(reason)
        }).finally(() => this.confirmLoading = false)
      }
    },
    //运营商增加备注信息
    addMerchantRemark() {
      if (this.checkRemark()) {
        this.confirmLoading = true
        this.getHttpServices().getOrderService().post('order/updateOrderRemark', {
          orderNo: this.orderNo,
          remark: this.merchantRemark
        }).then(res => {
          this.$message.success('备注保存成功')
          this.merchantRemark = ''
          this.remarkVisible = false
          this.getOrderDetails()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.confirmLoading = false)
      }
    },
    //是否显示备注及保存备注按钮
    getOrderRemark(data) {
      const { orderSource, orderDistributionId, orderSupplierId } = data || {}
      const merchantId = this.merchantId
      //订单来源:1一级分销商销售订单(分销订单) 2一级分销商的二级分销商销售订单(分销订单) 3自有商品订单(自销订单) 4一级分销商采购的订单(分销采购订单) 5供应商的二级分销商销售订单(分销订单) 6一级分销商的二级分销商采购订单(分销采购订单) 7供应商的二级分销商采购订单(分销采购订单)' ,
      const distSourceList = ['1', '2', '4', '6', '11', '12']
      // 统一转字符串，避免字符串匹配失效
      const source = String(orderSource)
      if (distSourceList.includes(source)) {
        return String(orderDistributionId) === String(merchantId)
      }
      return String(orderSupplierId) === String(merchantId)
    },
    // getOrderRemark(data) {
    //   //订单来源:1一级分销商销售订单(分销订单) 2一级分销商的二级分销商销售订单(分销订单) 3自有商品订单(自销订单) 4一级分销商采购的订单(分销采购订单) 5供应商的二级分销商销售订单(分销订单) 6一级分销商的二级分销商采购订单(分销采购订单) 7供应商的二级分销商采购订单(分销采购订单)' ,
    //   if (data.orderSource == 1 || data.orderSource == 2 || data.orderSource == 4 || data.orderSource == 6 || data.orderSource == 11 || data.orderSource == 12) {
    //     if (data.orderDistributionId == this.merchantId) {
    //       return true
    //     }
    //     return false
    //   } else {
    //     if (data.orderSupplierId == this.merchantId) {
    //       return true
    //     }
    //     return false
    //   }
    // },
    // 主动退款验证(练习手写Promise)
    refundFormParams() {
      return new Promise((resolve, reject) => {
        this.refundform.validateFields((err, values) => {
          this.getLogUtils().logWithTag('表单数据', values)
          if (!err) {
            resolve(values)
          } else {
            reject(values)
          }
        })
      })
    },
    //验证商家主动退款
    checkThinkRefund() {
      //orderSourceDisplay分销订单1   自销订单2   分销采购订单3   云仓分销订单4
      //orderSourceDisplay==2||orderSourceDisplay==4||orderSourceDisplay==3
      const orderSourceDisplay = this.orderBasicInfo.orderSourceDisplay
      if (this.isThinkRefund) {
        if (Number(this.reundLogThinkAmount) < Number(this.orderBasicInfo.refundMinAmt)) {
          this.$message.error('退款金额不能小于' + this.orderBasicInfo.refundMinAmt + '元')
          return false
        }
        if (Number(this.reundLogThinkAmount) > this.orderBasicInfo.refundMaxAmt) {
          this.$message.error('退款金额不能大于最大退款金额')
          return false
        }
        if (this.orderBasicInfo.refundCommissionFlag) {
          if (Number(this.refundCommissionAmount) > this.orderBasicInfo.refundCommissionAmount) {
            this.$message.error('扣分销佣金不能大于最大可扣金额')
            return false
          }
        }
      }
      return true
    },
    showkInitRefundModal() {
      this.InitRefundVisible = true
    },
    handleInitRefund(e) {
      e.preventDefault()
      this.refundFormParams().then(res => {
        this.getLogUtils().logWithTag('主动退款默认表单数据', res)
        this.reundLogThinkAmount = res.reundLogThinkAmount
        this.refundCommissionAmount = res.refundCommissionAmount
        this.refundRemarks = res.refundRemarks
        this.getApplyRefund()
      }).catch(err => {
        this.getLogUtils().logWithTag('错误', err)
      })
    },
    // 主动退款接口
    getApplyRefund() {
      if (this.checkThinkRefund()) {
        let params = {}
        params.refundLogOrderNo = this.orderNo
        params.refundRemarks = this.refundRemarks
        params.refundType = 2 //退款方式 1.客户申请退款 2.商家主动退款 ,
        params.reundLogAgreeOrCancel = 1 // 退款这节点申请-同意-拒绝 0 代表申请 1 代表同意 2 代表拒绝 ,
        params.reundLogAmount = this.reundLogThinkAmount
        params.flag = this.continueVisible
        params.refundCommissionAmount = this.refundCommissionAmount
        this.confirmLoading = true
        this.getHttpServices().getPayApiService().post('refund/applyRefundByOperator', params).then(res => {
          this.InitRefundVisible = false
          this.continueVisible = false
          this.$message.success('主动退款成功')
          this.refundform.resetFields()//清除信息
          this.getOrderDetails()
        }).catch(reason => {
          this.getLogUtils().logWithTag('错误信息', reason)
          if (reason.status == -164) {
            this.continueVisible = true
            this.compensationMoney = reason.data
            this.compensationType = 2
          }
          this.showNetWorkErrorMessage(reason)
        }).finally(() => this.confirmLoading = false)
      }
    },
    // 物流信息
    showLogisticsModal() {
      this.logisticsVisible = true
      this.getCourierServicesCompany(this.scrollPage)
      this.getHttpServices().getOrderService().get('order/getCommodityOrderExpress?orderNo=' + this.orderNo, '').then(res => {
        this.getLogUtils().logWithTag('查询数据', res)
        if (res && res.length > 0) {
          res.forEach(item => {
            item.isDisabled = true
          })
        }
        this.logisticsForm.dtoList = res ? res : []
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    remove(item, index) {
      this.logisticsForm.dtoList = this.logisticsForm.dtoList.filter((item, i, a) => i != index)
    },
    add() {
      if (this.logisticsForm.dtoList.length < 10) {
        this.logisticsForm.dtoList.push({
          expressCompanyName: undefined,
          expressNo: ''
        })
      } else {
        this.$message.error('最多10个物流信息')
      }
    },
    handleLogisticsOk() {
      this.$refs.logisticsForm.validate(valid => {
        if (valid) {
          this.confirmLoading = true
          this.getHttpServices().getOrderService().post('api/v2/orderManage/editCommodityOrderExpress', {
            orderNo: this.orderNo,
            shipDto: this.logisticsForm.dtoList
          }).then(res => {
            if (res) {
              this.$message.warning(res)
            } else {
              this.$message.success('保存成功')
            }
            this.logisticsVisible = false
            this.getOrderDetails()
          }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.confirmLoading = false)
        }
      })
    },
    showCloseOrderModal() {
      let that = this
      this.$confirm({
        title: '请确认是否关闭此订单?',
        onOk() {
          that.closeOrder()
        },
        onCancel() {
          that.$message.warning('已取消')
        }
      })
    },
    closeOrder() {
      this.getHttpServices().getOrderService().post('api/v2/orderManage/closeOrder', {
        orderNo: this.orderNo
      }).then(res => {
        this.$message.success('订单关闭成功')
        this.getOrderDetails()
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getCodeColumns() {
      return [
        {
          title: this.isElectronicCode ? '电子码' : '预约码',
          key: 'code',
          dataIndex: 'code'
        },
        {
          title: '预约订单号',
          key: 'reserveOrderNo',
          dataIndex: 'reserveOrderNo',
          scopedSlots: { customRender: 'actionOrderNo' }
        },
        {
          title: '当前状态',
          key: 'codeStatusStr',
          dataIndex: 'codeStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    getCouponCodeInfo() {
      this.getHttpServices().getCouponService().post('couponSetInfo/getCouponCodeInfo/' + this.orderNo).then(res => {
        this.getLogUtils().logWithTag('getCouponCodeInfo', res)
        if (res && res.length > 0) {
          this.couponCodeList = res
          this.isElectronicCode = res[0].couponType === 'DZM'
          this.couponCodeList.forEach((item, index) => {
            this.$set(item, 'key', index)
          })
        }
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onClickSend(record) {
      this.getLogUtils().logWithTag('onClickSend', record)
      this.sendForm.phone = record.phone
      this.sendForm.orderNo = record.preSaleOrderNo
      this.sendForm.redeemCode = record.code
      this.sendForm.couponId = record.couponId
      this.sendForm.sendFlag = record.sendFlag
      this.getSendSmsDetail()
    },
    getSendSmsDetail() {
      let params = {
        couponId: this.sendForm.couponId,
        redeemCodeList: [this.sendForm.redeemCode]
      }
      this.getHttpServices().getCouponService().post('couponSetInfo/getCouponCodeSms', params)
        .then(res => {
          if (res) {
            this.sendForm.smsContent = res
            this.sendForm.sendFlag = true
          }
          this.couponSendDialogVisible = true
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    onClickCancel(record) {
      this.getLogUtils().logWithTag('onClickCancel', record)
      const params = {
        codeList: [record.code],
        status: 3
      }
      this.getHttpServices().getCouponService().post('couponSetInfo/updateStatus', params)
        .then(res => {
          this.$message.success('作废成功')
          this.getCouponCodeInfo()
        }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    cancelDialog() {
      this.couponSendDialogVisible = false
    },
    submitSendEvent(record) {
      this.getLogUtils().logWithTag('===submitEvent====', record)
      this.submitSendLoading = true
      let params = {
        couponId: record.couponId,
        message: record.message,
        phone: record.phone,
        orderNo: record.orderNo,
        smsContent: record.smsContent,
        redeemCodeList: [record.redeemCode],
        sendFlag: record.sendFlag
      }
      this.getHttpServices().getCouponService().post('couponSetInfo/sendCouponCodeSms', params)
        .then(res => {
          this.couponSendDialogVisible = false
          this.$message.success('成功发送')
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.submitSendLoading = false)
    },
    onClickOrderNo(record) {
      this.openNewPage('CouponOrderDetail', { orderNo: record.reserveOrderNo })
    },
    getRefundColumns() {
      return [
        {
          title: '姓名',
          key: 'customerInfoName',
          dataIndex: 'customerInfoName'
        },
        {
          title: '证件号',
          key: 'customerInfoIdCard',
          dataIndex: 'customerInfoIdCard'
        },
        {
          title: '联系电话',
          key: 'customerInfoPhone',
          dataIndex: 'customerInfoPhone'
        }
      ]
    },
    previewEvent(url) {
      this.imgDialogVisible = true
      this.imageUrl = url
    }
  }
}
</script>
<style lang="less">
@import url('../../CustomPage.less');

.heading {
  font-size: 20px;
  font-weight: 400;
  color: #000;
}

.order-big {
  font-size: 20px;
  font-weight: bold;
  color: #000;
}

.mb20 {
  margin-bottom: 20px;
}

.ul-lh {
  padding-left: 0;
}

ul, li {
  list-style: none;
  margin: 0;
}

.btns-list {
  .mb10 {
    margin-bottom: 10px;
  }

  .ant-btn + .ant-btn {
    margin-left: 10px;
  }
}

input {
  max-width: 500px;
}

.title-refund {
  font-size: 14px;
  font-weight: 500;
  padding: 4px 0px;
  color: rgba(0, 0, 0, 0.85);
}

.install-ly {
  .ant-timeline-item-content {
    width: 200px;
  }
}

.model-box {
  .ant-form-item {
    margin-bottom: 10px;
  }
}

.time-line {
  .ant-timeline-item-content {
    width: 100%;
  }
}

.employee-card-img {
  width: 150px;
  height: 100px;
  cursor: pointer;
}
</style>
